import { api } from "@/axios";
import responseHandler from "@/responseHandler.js";
//import { adSetter } from "core-js/fn/symbol";

const state = {
  ads: [],
};

const getters = {
  getAds: (state) => state.ads,
  getAdById: (state) => (id) => state.ads.find((x) => x.id == id),
};

const actions = {
  async fetchAds({ commit }) {
    try {
      const resp = await api.get("/ads");
      if (resp.status == 200) {
        console.log("dddd", resp.data);
        const ads = resp.data.data;
        commit("setAds", ads);
      }
    } catch (error) {
      return false;
    }
  },
  async updateAd({ commit }, ad) {
    try {
      const id = ad.id;
      ad._method = "patch";

      const resp = await api.post(`/ads/${id}`, ad);
      if (resp.status == 200) {
        const ad = resp.data.data;
        commit("updateAd", ad);
      }
      return responseHandler.respH1(resp);
    } catch (error) {
      return responseHandler.respH1(error.response);
    }
  },
  async addAd({ commit }, ad) {
    try {
      const resp = await api.post(`/ads`, ad);
      console.log("resp", resp);

      if (resp.status == 201) {
        const ad = resp.data.data;

        commit("addAd", ad);
      }
      return responseHandler.respH1(resp);
    } catch (error) {
      return responseHandler.respH1(error.response);
    }
  },
  async deleteAd({ commit }, id) {
    try {
      const resp = await api.delete(`/ads/${id}`);

      if (resp.status == 204) {
        commit("deleteAd", id);
      }
      return responseHandler.respH1(resp);
    } catch (error) {
      return responseHandler.respH1(error.response);
    }
  },
};

const mutations = {
  setAds(state, ads) {
    state.ads = ads;
  },
  updateAd(state, ad) {
    const id = ad.id;
    const index = state.ads.findIndex((ad) => ad.id == id);
    if (index !== -1) {
      state.ads[index] = ad;
    }
  },
  addAd(state, ad) {
    state.ads.unshift(ad);
    console.log("ads", state.ads);
    console.log("ad", ad);
  },

  deleteAd(state, id) {
    const index = state.ads.findIndex((p) => p.id == id);
    if (index !== -1) {
      state.ads.splice(index, 1);
    }
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
